






import { mapGetters } from 'vuex'
import Button from '@/types/components/Button.interface'
import Analytics from '@/services/Analytics'
import Vue from 'vue'
import ActiveHomeDashboard from '@/components/ActiveHomeDashboard.vue'
import ChooseNumberWidget from '@/components/ChooseNumberWidget.vue'
import CalendlyWidget from '@/components/CalendlyWidget.vue'
import ReportingItems from '@/components/ReportingItems.vue'
import TrialingHomeDashboard from '@/components/TrialingHomeDashboard.vue'
export default Vue.extend({
    components: {
        ActiveHomeDashboard,
        CalendlyWidget,
        ChooseNumberWidget,
        ReportingItems,
        TrialingHomeDashboard
    },
    data() {
        return {
            //  The height of the primary content
            toolbar: {
                title: 'Home'
            }
        }
    },
    mounted() {
        // If query param includes popWelcome
        // if (this.$route.query.popWelcome) {
        //     // Pop Dialog
        //     this.displayWelcomePopup()
        // }
        //  If query param includes popNewUserWelcome
        if (this.$route.query.popNewUserWelcome) {
            // Pop Dialog
            this.displayNewUserWelcomePopup()
        }

        //  Grab the provider route query
        const provider = this.$route.query.provider

        //  If no provider, we are done
        if (!provider) return

        //  Else if we arrive here at the end of QBO/Xero OAuth flow, we pop a special message
        this[`${provider}ConnectionComplete`]()
    },
    computed: {
        ...mapGetters({
            isApp: 'isApp',
            invitations: 'teammatesInvitations',
            meteredRate: 'meteredRate',
            plan: 'plan',
            productTier: 'productTier',
            smsAccount: 'smsAccount',
            subscription: 'subscription',
            tenant: 'tenant',
            trialing: 'trialing',
            user: 'user'
        }),
        // Gets us the amount of invitations sent and adds it to our user count
        invitationCount(): number {
            //  If no invitations, return 0
            if (!this.invitations) return 0

            //  Else count the total that aren't snapdesk/messagedesk/support
            return this.invitations.filter(
                (x) =>
                    x.role_id !== 5 &&
                    !x.email.includes('@snapdesk.app') &&
                    !x.email.includes('@messagedesk.com')
            ).length
        },
        isAndroid(): boolean {
            return this.$store.getters.isMobile('nonIos')
        },
        isMobile(): boolean {
            return this.$store.getters.isMobile()
        },
        operator(): boolean {
            return !this.$store.getters.userHasPermission(2)
        },
        phoneNumber(): string {
            //  Grab our sms account
            const account = this.smsAccount

            //  If no account, return 'n/a'
            if (!account) return 'N/A'

            //  Else, grab our msisdn
            const msisdn = account.msisdn

            //  Convert this to a human-readable format
            return this.$options.filters.phone(msisdn)
        },
        // Return the date that the client will be charged again
        subNextBillDate(): Date | string {
            // If they aren't on a plan (trailing), no date is given
            if (!this.subscription) return null

            // Otherwise return the date
            return this.subscription.current_period_end
        },
        SettingsSmsNumber(): object {
            // This is meant only for legacy users before the new onboarding update so that the home page can render for them
            if (this.smsAccount === null) {
                return {
                    num: 'n/a',
                    txt: null
                }
            }

            //  Return text for existing registered number
            return {
                num: this.$options.filters.phone(this.smsAccount.msisdn),
                txt: null
            }
        },
        // Gives us the total number of credits a user is allowed to use before getting metered billing
        totalCredits(): number {
            // If they aren't on a subscription, no credits given
            if (!this.subscription) return 0

            // If they aren't on a plan, no credits given
            if (!this.plan.metadata) return 0

            //  If they are trialing, return 50
            if (this.trialing) return 50

            // Store the user's metadata from their plan
            const meta = this.plan.metadata

            // If they have no message allowance on their plan nor do they have credits on a trial plan, no credits given
            if (!meta.message_allowance && !meta.trial_message_allowance) return 0

            // Otherwise get the amount of credits they're allowed to use from one of their plans, either trialing or payment
            const amt =
                parseInt(meta.message_allowance) || parseInt(meta.trial_message_allowance)

            // Return the amount of credits given or 0 in case of edge case
            return amt || 0
        },
        // This count includes current users and invited users that haven't registered yet
        userCount(): number {
            return this.$store.getters.userCount
        },
        // Max amount of user's allowed
        userLimit(): number {
            //  Grab our total number of users from our stripe plan
            return this.$store.getters.getLimit('user')
        }
    },
    methods: {
        //  The height of the primary content
        calculateContentHeight(): number {
            //  Get the height of the view
            let body = document.body.clientHeight

            //  Define the toolbars offset
            let toolbars = 70

            //  define the padding offset (accounts for padding on smAndUp)
            let padding = 25

            //  Define the app bottom navbar offset
            let navbar = 15

            //  Subtract the height of our app bar, toolbars, navbar, and padding
            let height = body - (toolbars + padding + navbar)

            //  Return height in pixels
            this.contentHeight = height

            return height
        },
        click(button: Button): void {
            //  Check if our button is disabled
            const disabled = button.disabled

            //  If it is then we will pop disabled
            if (disabled) return this.disabledPopup()

            //  Else, use the callback on our button
            return button.callback()
        },
        complete(id: string): boolean {
            //  Created Account is always true
            if (id === 'createdAccount') return true

            //  If the tenant is on a paid subscription, all tutorials are just marked as completed
            if (this.tenant.account_status == 'active') return true

            //  Return tutorial status
            if (this.tenant.tutorial) return this.tenant.tutorial[id]

            //  Otherwise return false
            return false
        },
        disabledPopup(): void {
            //  Open a dialog informing user they cannot
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Button Disabled',
                text: "You don't have permission to access this feature. Please contact your account's admin to perform this task or have them update your account permission",
                icon: 'mdi-alert',
                color: 'primary',
                closeable: true
            })
        },
        displayNewUserWelcomePopup(): void {
            //  Pop an app form with the new-user-welcome-popup
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'new-user-welcome-popup',
                closeable: false,
                closeOnSubmit: true,
                callback: () => {
                    //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
                    const query = Object.assign({}, this.$route.query)

                    // Remove popWelcome query param since it is no longer needed, keep the rest
                    const { popNewUserWelcome, ...newQuery } = query

                    // Set query to be passed to route
                    const modifiedQuery = '?' + window.toUrlParams(newQuery)

                    //  Update the current url
                    this.$router.push(`${modifiedQuery}`)
                }
            })
        },
        displayWelcomePopup(): void {
            //Pop an app form with the welcome popup component to verify phone
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                color: 'primary',
                component: 'welcome-popup',
                closeable: false,
                closeOnSubmit: true,
                class: 'pa-2',
                callback: (object: object) => {
                    //  Update our organization name
                    this.updateOrganizationName(object)

                    //  Do our analytics tracking
                    this.trackWelcomePopup(object)

                    //  Clone the current query params (we do this to avoid the Vue duplicate naviagtion error)
                    const query = Object.assign({}, this.$route.query)

                    // Remove popWelcome query param since it is no longer needed, keep the rest
                    const { popWelcome, ...newQuery } = query

                    // Set query to be passed to route
                    const modifiedQuery = '?' + window.toUrlParams(newQuery)

                    //  Update the current url
                    this.$router.push(`${modifiedQuery}`)
                }
            })
        },
        goToAccountSettings(): void {
            //  Go to account settings
            this.$router.push('/account')
        },
        goToAddUser(): void {
            //  Go to invite user route
            this.$router.push(`/teammates?create=true`)
        },
        goToCsvImport(): void {
            this.$router.push('/csv/import')
        },
        goToFreeCredits(): void {
            // Navigate to free credits page
            this.$router.push('/free-credits')
        },
        goToInbox(): void {
            //  Go to inbox
            this.$router.push('/inbox')
        },
        goToLocalNumber(): void {
            // Link that takes user to local number request form
            window.open(
                'https://messagedesk.typeform.com/to/eH7189he',
                this.isApp ? '_system' : '_blank'
            )
        },
        goToManagePlan(): void {
            // If user is trialing, we send them to a different billing page
            // this.$router.push(
            //     `${
            //         this.subscription.status == 'trialing'
            //             ? '/billing/plan'
            //             : '/billing/manage'
            //     }`
            // )
            this.$router.push('/billng/manage')
        },
        goToLink(link: string): void {
            window.open(link, this.isApp ? '_system' : '_blank')
        },
        goToTextEnableLandline(): void {
            // Go to Text landline form
            window.open(
                'https://messagedesk.typeform.com/to/mDz8wsFX',
                this.isApp ? '_system' : '_blank'
            )
        },
        goToQbo(): void {
            this.$router.push('/qbo')
        },
        goToXero(): void {
            this.$router.push('/xero')
        },
        qboConnectionComplete(): void {
            //  Activate sync progress
            this.$store.commit('dataProviderSyncProgressSet', {
                message: 'Beginning Sync',
                percent: 0
            })

            //  Send the sync request to the API
            this.$store.dispatch('qboSync')
        },
        sendBroadcast(): void {
            //  Maybe report to analytics?

            //  Route to broadcast create
            this.$router.push('/broadcasts/create')
        },
        sendText(): void {
            //  Maybe report to analytics?
            //  Route to inbox
        },
        trackWelcomePopup(object: object): void {
            //  Notify segment
            Analytics.track('OrganizationNameUpdated', {
                //  @ts-ignore
                organization_name: object.organization_name
            })

            //  Report Track data to segment
            Analytics.segmentTrack('OnboardingStarted', {
                ...object,
                mobilephone: this.user.mobilephone,
                email: this.user.email,
                chosen_plan: this.productTier
            })

            //  @ts-ignore Report our broadcast size preference
            if (object.broadcast_size) {
                //  Report to segment
                Analytics.track('BroadcastSizePreference', {
                    //  @ts-ignore
                    choice: object.broadcast_size,
                    email: this.user.email
                })
            }

            //  Do an extra group call here for MCS
            window.analytics.group(this.tenant.id, {
                //@ts-ignore
                requested_area_code: object.area_code,
                name: this.tenant.company_name,
                users: this.userCount
            })
        },
        updateOrganizationName(object: object): void {
            //  Grab our tenant
            const tenant = this.tenant

            //  @ts-ignore Update our user with the organization name
            tenant.company_name = object.organization_name

            //  Send the update
            this.$store.dispatch('tenantPut', tenant)
        },
        xeroConnectionComplete(): void {
            //  Activate sync progress
            this.$store.commit('dataProviderSyncProgressSet', {
                message: 'Beginning Sync',
                percent: 0,
                model: 'Xero Data'
            })

            //  Send the sync request to the API
            this.$store.dispatch('xeroSync')
        }
    }
})
